
import Vue from "vue";
import { FTextareaField, FTextField } from "@fkui/vue";
import { mapFields } from "vuex-map-fields";
export default Vue.extend({
    name: "AnnatPrivatpersonFieldGroup",
    components: {
        FTextareaField,
        FTextField,
    },
    computed: {
        ...mapFields([
            "observationer.annatMisstanke.hurLangeFelUtbetalt",
            "observationer.annatMisstanke.inteRattTillErsattning",
        ]),
    },
});
